import { Checkpoint } from "./tourPlayback";

export const findLastCheckpoint = (checkpoints: Checkpoint[]) => {
  if (!checkpoints || checkpoints.length === 0) {
    return null;
  }

  const lastCheckpointTrace = checkpoints[checkpoints.length - 1];

  const stepCheckpointTraces = checkpoints.filter((checkpoint) => checkpoint.stepId === lastCheckpointTrace.stepId);
  if (stepCheckpointTraces.length === 0) {
    return null;
  }

  return stepCheckpointTraces[0];
};
